// src/index.ts
const NO_PREF = "NO_PREF";
const STACKED = "STACKED";
const FRAGMENTED = "FRAGMENTED";
const NO_REST = "NO_REST";
const assignmentPreferences = [
	NO_PREF,
	STACKED,
	FRAGMENTED,
	NO_REST
];
function isAssignmentPreference(assignment) {
	return assignmentPreferences.includes(assignment);
}
export { FRAGMENTED, NO_PREF, NO_REST, STACKED, assignmentPreferences, isAssignmentPreference };

//# sourceMappingURL=index.mjs.map